import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { useData } from "@/context/DataContext";
import { WhatsAppButton } from "@/components/site/WhatsButton";
import { Reveal } from "@/components/site/Reveal";

export function GuideCta({ titolo = "Hai bisogno dell'intervento di un professionista?" }) {
  return (
    <Reveal className="mt-10 rounded-2xl border border-white/10 bg-av-green-dark/30 p-8 text-center" >
      <div style={{ backgroundColor: "transparent" }}>
        <h2 className="font-display text-2xl sm:text-3xl text-av-white">{titolo}</h2>
        <p className="mt-3 text-av-gray max-w-xl mx-auto">Animaverde si occupa di manutenzione del verde, potature, irrigazione, trattamenti fitosanitari, abbattimenti e fresatura dei ceppi a Ferno e nei comuni limitrofi.</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/contatti" className="inline-flex items-center gap-2 rounded-full bg-av-bright text-av-black px-6 py-3 text-sm font-semibold hover:bg-av-lime transition-colors">Richiedi un preventivo</Link>
          <WhatsAppButton variant="outline" />
          <Link to="/diagnostica-giardino" className="inline-flex items-center gap-2 rounded-full border border-white/25 text-av-white px-6 py-3 text-sm font-semibold hover:border-av-lime hover:text-av-lime transition-colors">
            <MessageCircle size={15} /> Descrivi il problema
          </Link>
        </div>
      </div>
    </Reveal>
  );
}

export function GuideCard({ g }) {
  return (
    <Link to={`/guide/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="group block rounded-2xl border border-white/10 p-6 hover:border-av-lime/50 transition-colors bg-av-green-dark/20" style={{ backgroundColor: "rgba(22,56,29,0.2)" }}>
      <h3 className="font-display text-xl text-av-white group-hover:text-av-lime transition-colors">{g.domanda || g.titolo}</h3>
      <p className="mt-2 text-sm text-av-gray line-clamp-2">{g.risposta_breve}</p>
      <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-av-lime">Leggi la guida <ArrowUpRight size={14} /></span>
    </Link>
  );
}
